import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-group",
  "use": "icon-group-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-group\"><defs><style type=\"text/css\"></style></defs><path d=\"M106.666667 869.333333h810.666666v53.333334H106.666667zM170.666667 101.333333v768h458.666666V101.333333H170.666667z m405.333333 768H224V154.666667h352v714.666666z\" fill=\"#0099ff\" p-id=\"11769\" /><path d=\"M576 330.666667v544h53.333333V384h170.666667v490.666667h53.333333V330.666667zM266.666667 266.666667h117.333333v53.333333H266.666667zM416 266.666667h117.333333v53.333333H416zM266.666667 453.333333h117.333333v53.333334H266.666667zM416 453.333333h117.333333v53.333334H416zM266.666667 640h117.333333v53.333333H266.666667zM416 640h117.333333v53.333333H416z\" fill=\"#0099ff\" p-id=\"11770\" /><path d=\"M693.333333 453.333333h53.333334v133.333334h-53.333334zM693.333333 624h53.333334v133.333333h-53.333334z\" fill=\"#0099ff\" p-id=\"11771\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/group.svg
// module id = hjGX
// module chunks = 81